export const LogoMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <path d="M40 12a22 22 0 1 0 12 34A18 18 0 1 1 40 12z" fill="currentColor" />
    <path d="M38 24l1.6 4.4L44 30l-4.4 1.6L38 36l-1.6-4.4L32 30l4.4-1.6z" fill="#C87D55" />
  </svg>
);

export const Logo = ({ testId = "nav-brand-logo" }) => (
  <a href="/#top" data-testid={testId} className="group flex items-center gap-2.5 text-[#2D2A26]">
    <span className="transition-transform duration-700 group-hover:rotate-[-25deg]"><LogoMark /></span>
    <span className="leading-none">
      <span className="block font-display text-2xl tracking-[0.18em]">SHAYA</span>
      <span className="block text-[10px] uppercase tracking-[0.32em] text-[#6E685F]">Spiritual Practice</span>
    </span>
  </a>
);
